/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1088
 */

var r = require(/* 168 */"../1648/168")
module.exports = !r(function () {
  function e() {}
  e.prototype.constructor = null
  return Object.getPrototypeOf(new e()) !== e.prototype
})
